import { useGateValue } from '@coursera-web/statsig';

/**
 * CDS Labs chat components — new ChatMessage UI.
 *
 * Gate: https://console.statsig.com/2aQACzHI81tdbY41wEZm3H/gates/cds-labs-chat-components
 */
export const useCdsLabsChatComponents = (): boolean => {
  return useGateValue('cds-labs-chat-components');
};
